export default {
	Slide: 'Yapboz',
	Puzzle: 'Yapboz',
	'The puzzle is open!': 'Yapboz açık!',
	'Congratulations!': 'Tebrikler!',
	'You get it': 'Sen kazandın',
	'You get the task done': 'Görevi tamamlıyorsun',

	'Show all blocked': 'Engellenenlerin tümünü göster',

	Author: 'Yazar',
	'Reset filters': 'Filtreleri sıfırla',

	Blocked: 'Engellendi',
	Unlocked: 'Engeli kaldırıldı',

	Change: 'Değiştir',

	'The student is blocked': 'Öğrenci engellendi',
	'The student is blocked with a new price':
		'Öğrenci yeni bir fiyatla engellendi',
	'To unlock this student, go to the "Restore" section':
		'Bu öğrencinin engelini kaldırmak için "Geri Yükleme" bölümüne gidin',

	'Before blocking, you can change the price for the student':
		'Engellemeden önce öğrenci için tarifeyi değiştirebilirsiniz',

	'Block student': 'Öğrenciyi engelle',

	'First month cost': 'İlk ay ücreti',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'UYARI! Görevi yeniden kaydettikten sonra, bu görevi tamamlamış öğrencilerin bulmacası kapanacak ve yeniden yapmaları gerekecek.',

	"You cannot do homework in the student's platform":
		'Öğrenci platformunda ödev yapamazsınız',

	'Restore the student ?': 'Öğrenciyi geri yüklemek istiyor musunuz ?',
	'Restore the teacher ?': 'Öğretmeni geri yüklemek istiyor musunuz ?',
	'Restore the franchise ?': 'Bayiliği geri yüklemek istiyor musunuz ?',

	'Transition to 50': "50'ye geçiş",
	'Transition to 100': "100'e geçiş",

	fifty: "50'ye geçiş",
	hundred: "100'e geçiş",

	Faces: 'Yüzler',

	Heroes: 'Kahramanlar',
	Clothes: 'Kıyafetler',
	Backgrounds: 'Arka planlar',
	Souvenirs: 'Hediyelik eşyalar',

	'Coming soon': 'Çok yakında',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Vay canına! Tebrikler, bu ürünü başarıyla satın aldınız.',
	'You can view all your purchases in the "Purchased" section':
		'"Satın Alınanlar" bölümünde tüm alışverişlerinizi görebilirsiniz',

	'Your savings': 'Biriktirdiklerin',
	'You can spend them on something interesting!':
		'Onları ilginç bir şeye harcayabilirsin!',
	'A student with this email address already exists':
		'Bu e-posta adresine sahip bir öğrenci zaten mevcut',

	'User with such email already exists':
		'Bu e-posta adresine sahip bir kullanıcı zaten mevcut',
	'Year of birth': 'Doğum yılı',
	Registration: 'Kayıt',
	'Surname of parents': 'Velinin soyisim',
	School: 'Okul',
	'Field is required': 'Bu alan zorunludur',
	'Select age': 'Yaşı seçin',
	'No such teacher for this year': 'Bu yıl için böyle bir öğretmen yok',
	'User with such phone number already exists':
		'Bu telefon numarasına sahip bir kullanıcı zaten mevcut',
	'You are successfully registered': 'Başarıyla kaydoldunuz',
	'Max length 20 chars': 'Maksimum uzunluk 20 karakter',
	'Після реєстрації вам надійде лист з логіном і паролем':
		'Kayıt olduktan sonra size giriş bilgileri ve şifre içeren bir e-posta gönderilecektir',

	'INTERNATIONAL SCHOOL': 'ULUSLARARASI OKUL',
	'Mental Arithmetic': 'Mental Aritmetik',
	'For children aged 5-14.': '5–14 yaş arası çocuklar için.',
	'Sign up for a trial lesson': 'Deneme dersine kaydolun',
	'Parents name': 'Velinin isim',
	'Childs age': 'Çocuğun yaşı',
	Country: 'Ülke',
	'Sign up': 'Kaydol',

	'Open offer agreement': 'Açık teklif sözleşmesi',
	'Participate in online Indigo Olympiad':
		'Indigo çevrim içi olimpiyatına katıl!',
	Participate: 'Katıl',
	export: 'Dışa aktar',

	wrong: 'Yanlış',
	right: 'Doğru',
	match: {
		addition: 'Hız Modu',
		multiply: 'Çarpma',
		divide: 'Bölme',
		abacus_random: 'Abaküs Rastgele',
		anzan: 'Anzan',
		negative: 'Negatif sayılar',
		column: 'Sütunlar',
	},
	timeIsOver: 'Süre doldu',
	timer: 'Zamanlayıcı',
	'Back to Lessons': 'Dersler listesine geri dön',
	'Create Lesson': 'Ders oluştur',
	Assign: 'Atamak',
	Home: 'Ana sayfa',
	'To cabinet': 'Hesaba git',
	'Create a homework': 'Ödev oluştur',
	January: 'Ocak',
	February: 'Şubat',
	March: 'Mart',
	April: 'Nisan',
	May: 'Mayıs',
	June: 'Haziran',
	July: 'Temmuz',
	August: 'Ağustos',
	'Group nickname': 'Grubun kullanıcı adı',
	September: 'Eylül',
	October: 'Ekim',
	November: 'Kasım',
	December: 'Aralık',
	Overall: 'Genel olarak',
	Active: 'Aktif',
	'Contract number': 'Sözleşme numarası',
	'For parents': 'Veliler için',
	'Choose lessons': 'Dersleri seçin',
	Save: 'Kaydet',
	'Students active': 'Aktif öğrenciler',
	Close: 'Kapat',
	'Change birthday': 'Doğum tarihini değiştir',
	Sent: 'Gönderildi',
	'Choose date': 'Tarihi seçin',
	'Include students': 'Öğrencileri dahil et',
	'Add service': 'Hizmet ekle',
	'Create folder': 'Klasör oluştur',
	Answer: 'Cevap',
	Price: 'Fiyat',
	'Date of creating': 'Oluşturulma tarihi',
	Month: 'Ay',
	unpaid: 'Ödenmedi',
	paid: 'Ödendi',
	'Excluded students': 'Devre dışı bırakılan öğrenciler',
	'Selected groups': 'Seçilen gruplar',
	Monday: 'Pazartesi',
	Tuesday: 'Salı',
	Wensday: 'Çarşamba',
	Thusday: 'Perşembe',
	Friday: 'Cuma',
	Saturday: 'Cumartesi',
	Sunday: 'Pazar',
	Mo: 'Pzt',
	Tu: 'Sal',
	We: 'Çar',
	Th: 'Per',
	Fr: 'Cum',
	Sa: 'Cmt',
	Su: 'Paz',
	End: 'Son',
	'Add discount': 'İndirim ekle',
	Edit: 'Düzenle',
	'Parent found': 'Ebeveyn bulundu',
	'Changes saved': 'Değişiklikler kaydedildi',
	'The passwords of the parent and the student should not coincide':
		'Veli ve öğrenci şifreleri aynı olmamalı',
	'Your region`s price is set to': 'Bölgenizin fiyatı şu şekilde ayarlandı',
	'and the holder`s reward is': 'hak sahibinin ödülü',
	'regardless of the set price': 'Belirlenen fiyattan bağımsız olarak',
	'The given password is not unique for this email':
		'Şifre bu e-posta ile benzersiz olmalı',
	'Enter a valid email address.': 'Lütfen geçerli bir e-posta adresi girin.',
	'The phone number entered is not valid':
		'Girilen telefon numarası geçerli değil',
	Holiday: 'Tatiller',
	'Working days': 'İş günleri',
	Street: 'Sokak',
	'Location name': 'Konum adı',
	District: 'İlçe',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Zihinsel Aritmetik, 5–14 yaş arasındaki çocukların zihinsel yeteneklerini ve zekasını hızla geliştiren bir hesaplama yöntemidir. Eğitim süreci, özel Japon Abaküs (Soroban) hesap aletleri üzerinde yürütülür.\nZihinsel aritmetik, beynin sağ ve sol yarım kürelerini aynı anda çalıştırarak, çocukların görsel hafızasını, dikkatini, yaratıcılığını, görsel düşünme yetilerini ve hızlı okuma eğilimlerini geliştirir.',
	'Field required': 'Bu alan zorunludur',
	'Type of legal activity': 'Hukuki faaliyetin türü',
	'Legal address': 'Resmî adres',
	'Registration number': 'Tescil numarası',
	'Add Group': 'Grup ekle',
	'Add Student': 'Öğrenci ekle',
	Add: 'Ekle',
	'Add file': 'Dosya ekle',
	Signin: 'Giriş',
	'Bonus days': 'Bonus günleri',
	'Bonus weeks': 'Bonus haftaları',
	'Are you sure you want to delete?': 'Silmek istediğinizden emin misiniz?',
	Delete: 'Sil',
	Days: 'Günler',
	Cancel: 'İptal et',
	Confirm: 'Onayla',
	Week: 'Hafta',
	Weeks: 'Haftalar',
	'Group age name': 'Yaş grubu adı',
	'Set bonus days': 'Bonus günleri ayarla',
	'Default language': 'Varsayılan dil',
	'With english': 'İngilizce ile',
	'Without english': 'İngilizcesiz',
	'Paid status': 'Ödeme durumu',
	'Not paid': 'Ödenmedi',
	Turnover: 'Ciro',
	Block: 'Engelle',
	// Blocked: 'Engellenenle',
	'On holidays': 'Tatilde',
	Language: 'Dil',
	Discounts: 'İndirimler',
	Message: 'Bildirimler',
	Subject: 'Konu',
	Homework: 'Ödev',
	'Homework ': 'Antrenman',
	'Homework on': 'Ödev için',
	'You need to complete the exercises': 'Tamamlamanız gereken görevler',
	// last Homework wins:
	HomeworkList: 'Ödevler',
	'Invoice for': 'Fatura',
	"PJSC CB 'PRIVATBANK' in Kyiv": "PJSC CB 'PRIVATBANK' Kiev şehri",
	Account: 'Hesap',
	Supplier: 'Tedarikçi',
	Buyer: 'Alıcı',
	'Bank code': 'Banka kodu ',
	'Type phone number or email':
		'Telefon numaranızı veya e-posta adresinizi girin',
	'Type password': 'Şifrenizi girin',
	'Forgot password': 'Şifrenizi mi unuttunuz',
	'Type your email': 'E-posta adresinizi girin',
	Send: 'Gönder',
	'Email sent': 'E-posta gönderildi',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Bu e-posta ile bir hesap varsa, erişimi geri almak için talimatları içeren bir e-posta göndereceğiz',
	'Back to the sign in': 'Girişe dön',
	'Password or login is not correct': 'Şifre veya kullanıcı adı yanlış',
	'Password recovery': 'Şifre kurtarma',
	'Type your new password here': 'Yeni şifrenizi buraya girin',
	'Set new password': 'Yeni şifreyi belirle',
	'Learn more': 'Daha fazla bilgi',
	'About Us': 'Hakkımızda',
	Company: 'Şirket',
	Jobs: 'İşler',
	Press: 'Media',
	'Terms of Use': 'Kullanım Şartları',
	'Privacy Policy': 'Gizlilik Politikası',
	'Need help?': 'Yardıma mı ihtiyacınız var?',
	'Contact us': 'Bizimle iletişime geçin',
	'Become franchise': 'Franchise olun',
	'Select language': 'Dil seçin',
	English: 'İngilizce',
	Russian: 'Rusça',
	Azerbaijani: 'Azerbaycan',
	Ukrainian: 'Ukraynaca',
	Polish: 'Lehçe',
	Management: 'Yönetim',
	'Master Franchise': 'Ana franchise',
	Franchise: 'Franchise',
	Teachers: 'Öğretmenler',
	Groups: 'Gruplar',
	Students: 'Öğrenciler',
	Student: 'Öğrenci',
	Parents: 'Veliler',
	Profile: 'Profil',
	'My profile': 'Profilim',
	Finance: 'Finans',
	Reports: 'Raporlar',
	Report: 'Rapor',
	Upload: 'Yükle',
	List: 'Liste',
	Payments: 'Ödemeler',
	Documents: 'Taranmış belgeler',
	Lessons: 'Dersler',
	Materials: 'Materyaller',
	Shop: 'Mağaza',
	Statistics: 'İstatistik',
	Settings: 'Ayarlar',
	Pages: 'Sayfalar',
	Logout: 'Çıkış',
	Dashboard: 'Kullanıcı paneli',
	'Access denied': 'Erişim engellendi',
	Create: 'Oluşturmak',
	New: 'Yeni',
	Download: 'İndir',
	Status: 'Durum',
	'Payment Date': 'Ödeme tarihi',
	'Payment Amount': 'Ödeme tutarı',
	'Start time': 'Ders başlama saati',
	'Group age': 'Grup yaşı',
	Junior: 'Küçükler',
	Average: 'Orta',
	Class: 'Sınıf',
	Older: 'Büyükler',
	Region: 'Bölge',
	Group: 'Grup',
	Person: 'Kişi',
	Finances: 'Finans',
	Actions: 'İşlem sayısı',
	'Send invoice': 'Fatura',
	'Download invoice': 'Faturayı indir',
	'Send email': 'E-posta gönder',
	'Create Student': 'Öğrenci oluştur',
	'The beginning of holidays': 'Tatillerin başlangıcı',
	'Start of study': 'Eğitimin başlangıcı',
	'Group name': 'Grup adı',
	'Group address': 'Grubun adresi',
	'Group teacher': 'Grubun öğretmeni',
	'Group students': 'Grubun öğrencileri',
	'Group statistics': 'Grup istatistikleri',
	Search: 'Arama',
	'General information': 'Genel bilgiler',
	'Phone number': 'Telefon numarası',
	'First name': 'İsim',
	Surname: 'Baba adı',
	'Last name': 'Soyisim',
	'Date of birth': 'Doğum tarihi',
	Password: 'Şifre',
	'Additional information': 'Ek bilgiler',
	'Id code': 'Kimlik kodu',
	Passport: 'Pasaport',
	'Without email newsletter': 'E-posta bülteni yok',
	'With email newsletter': 'E-posta bülteni ile',
	'Financial information': 'Finansal bilgiler',
	Royalty: 'Rüçhan ücreti',
	'PR contribution': 'PR katkısı',
	Currency: 'Para birimi',
	Comment: 'Yorum',
	Paid: 'Ödendi',
	Invoices: 'Faturalar',
	Bills: 'Faturalar',
	Acts: 'Belgeler',
	Scan: 'Tarama',
	Level: 'Seviye',
	'Action with numbers': 'İşlem sayısı',
	'Action with number': 'İşlem sayısı',
	'Number of expressions': 'Örnek sayısı',
	'Number of expression': 'Örnek sayısı',
	'Imaginary abacus': 'Hayali abaküs',
	'Period report': 'Rapor dönemi',
	City: 'Şehir',
	'Full name franchise': 'Franchise sahibinin tam adı',
	'Сost of education': 'Eğitim maliyeti',
	'Turnover franchise': 'Ciro',
	'Discount sum': 'İndirim tutarı',
	Proprietor: 'Sahip',
	'Additional products and services': 'Ek ürünler ve hizmetler',
	'Full name student': 'Öğrencinin tam adı',
	'Period of study': 'Eğitim süresi',
	'Bonus-days': 'Bonus günler',
	'Amount of days': 'Gün sayısı',
	'Total days': 'Toplam gün',
	'Language of instruction': 'Eğitim dili',
	Teacher: 'Öğretmen',
	Discount: 'İndirim',
	Remuneration: 'Rüçhan ücreti',
	Goods: 'Ürünler',
	'Date of creation': 'Oluşturulma tarihi',
	'Date of payment': 'Ödeme tarihi',
	'Goods (works, services)': 'Ürünler (çalışmalar, hizmetler)',
	Quantity: 'Miktar',
	Units: 'Birimler',
	Amount: 'Toplam',
	Sum: 'Tutar',
	'Sum Sub': 'Hızlandırma',
	Financial: 'Finansal',
	Additional: 'Ek',
	General: 'Genel',
	Total: 'Toplam',
	SaveAgain: 'Kaydet',
	'Including with': 'Dahil',
	'Training materials': 'Eğitim materyalleri',
	'Learning contract': 'Eğitim sözleşmesi',
	Games: 'Oyunlar',
	'NUMBER OF 11 TO 120': '11 DEN 120 YE KADAR SAYILAR',
	Complexity: 'Zorluk',
	Start: 'Başlat',
	'Speedy numbers': 'Hızlandırma',
	Anzan: 'Anzan',
	'Abacus is random': 'Abaküs rastgele',
	Multiplication: 'Çarpma',
	Division: 'Bölme',
	Abacus: 'Abaküs',

	'Multiplying by 20': "20'ye kadar çarpma",
	Squared: 'Karesi alınmış',
	'Division to 20': "20'ye kadar bölme",
	Speed: 'Hız',
	Repeat: 'Tekrar etmek',
	'Game type': 'Oyun türü',
	'Digit type': 'Sayı türü',
	Digit: 'Sayı',
	Time: 'Süre',
	Oral: 'Mental hesaplama',
	Second: 'Saniye',
	'Calculation method': 'Hesaplama yöntemi',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Sadece negatif sayılar, ifadenin zorluk derecesine bağlı olarak 99,999,9999 vb. ile başlar: -9, -2, -3, -1 ...',
	'Only subtraction': 'Sadece çıkarma',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		"Sadece toplama, 0'dan başlar. Örnek: +1, +4, +6, +9, +5 ...",
	'Only add': 'Sadece toplama',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		"Sayılar rastgele düşer, 0'dan başlar. Örnek: +3, -5, -1, +9, -2 ...",
	'Random numbers': 'Rastgele sayılar',
	'CHOOSE COMPLEXITY:': 'ZORLUK SEVİYESİNİ SEÇİN:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'SAYIYLA YAPILAN İŞLEM SAYISI',
	FAMILY: 'AİLE',
	'BIG FRIENDS': 'BÜYÜK ARKADAŞLAR',
	'LITTLE FRIENDS': 'KÜÇÜK ARKADAŞLAR',
	'JUST FRIENDS': 'BAŞLANGIÇ SEVİYE ARKADAŞLAR',
	'big friends': 'büyük arkadaşlar',
	'small friends': 'küçük arkadaşlar',
	elementary: 'temel seviye arkadaşlar',
	family: 'aile',
	Sound: 'Ses',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Tebrikler! Başarıyla tamamladınız! Şimdi bir sonraki alıştırmalara geçebilirsiniz!',
	'RIGHT. ANSWER:': 'DOĞRU. CEVAP:',
	CORRECT: 'DOĞRU',
	'NOT CORRECT': 'YANLIŞ',
	'Try again': 'Tekrar deneyin',
	expression: 'örnek',
	next: 'sonraki',
	Next: 'Sonraki',
	Previous: 'Önceki',
	Loading: 'Yükleniyor',
	back: 'geri',
	Back: 'Geri',
	ANSWER: 'CEVAP',
	Lesson: 'Ders',
	'History statistics': 'İstatistik geçmişi',
	Open: 'Aç',
	'Game statistics per day': 'Günlük oyun istatistikleri',
	'Total played games': 'Toplam oynanan oyun',
	'Total correct answers': 'Toplam doğru cevap',
	'Total played:': 'Toplam oynanan:',
	Feedback: 'Geri bildirim',
	'Leave a review': 'Yorum bırakın',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Bize geri bildirim veya isteklerinizi bırakın, çalışmalarımızda mutlaka değerlendireceğiz.',
	'Payment history': 'Ödeme geçmişi',
	'Payment status': 'Ödeme durumu',
	Pay: 'Öde',
	Payer: 'Alıcı',
	'Getting a discount': 'İndirim almak',
	Training: 'Antrenman',
	Tasks: 'Görevler',

	'Current task': 'Mevcut görev',
	'Only task': 'Görev',
	'Next tasks': 'Sonraki görevler',
	'Online abacus': 'Çevrim içi abaküs',
	'Base 50/100': 'Taban 50/100',
	multiply_base: 'Taban 50/100',
	divided: 'Bölünen',
	'Do not show this instruction again': 'Bu talimatı tekrar gösterme',
	'Instructions for homework': 'Ödev talimatları',
	divider: 'Bölen',
	'Multiplication table': 'Çarpım tablosu',
	Restore: 'Geri yükle',
	Left: 'Kalan',
	'Restore Hierarchy': 'Hiyerarşiyi geri yükle',
	total: 'toplam',
	active: 'aktif',
	blocked: 'engellenmiş',
	pageError: {
		403: 'Erişim reddedildi.',
		404: 'Bu sayfa mevcut değil. Lütfen tekrar deneyin.',
		500: 'Sunucu yanıt vermiyor. Lütfen tekrar deneyin.',
	},
	error: {
		'Account deactivated': 'Hesabınız devre dışı bırakılmıştır',
	},
	modalNewVersion: {
		text: 'Eski bir site sürümünü kullanıyorsunuz.\nGüncelleme mevcuttur.',
		btn: 'Güncelle',
	},
	games: {
		negativeNumbers: 'Negatif sayılar',

		pause: 'Duraklat',
		resume: 'Devam et',

		columns: {
			name: 'Sütunlar',
			users: 'Oyuncu sayısı',
			user: 'Oyuncu',
			userNames: 'Oyuncu isimleri',
		},
	},
	'Indigo-dollars': 'İndigo-dolar',
	Balance: 'Bakiye',

	modalIndigoDollars: {
		submit: 'Gönder',
		cancel: 'İptal',
		title: 'İndigo-dolar',
		balance: 'Mevcut bakiye',
		amount: 'Miktar',
		reason: 'Açıklama',
	},

	modalAddNotification: {
		title: 'Bildirim ekle',
		submit: 'Gönder',
		cancel: 'İptal',
		empty: 'Bildirim yok',
	},

	modalTransactionsHistory: {
		title: 'Ödeme geçmişi',
		type: {
			withdraw: 'Çekim',
			deposit: 'Yatırma',
		},
		empty: 'Ödeme listesi boş',
	},

	modalCopyHomework: {
		title: 'Ödev kopyalama',
		label: 'Ödevi kopyalamak istediğiniz tarihi seçin',
		submit: 'Kopyala',
		cancel: 'İptal',
	},

	reportsPage: {
		history: {
			title: 'Değişiklik geçmişi',
			empty: 'Liste boş',
			table: {
				date: 'Değişiklik tarihi',
				field_name: 'İşlem',
				old_value: 'Eski değer',
				new_value: 'Yeni değer',
				user: 'Kullanıcıda değiştirildi',
			},
		},
	},

	pageShop: {
		title: 'Mağaza',
		description:
			'Mağazada, kişisel alanınızın görsel görünümünü geliştirmek için çeşitli ürünler satın alabilirsiniz.',

		tabs: {
			all: 'Tüm ürünler',
			purchased: 'Satın alınanlar',
		},

		item: {
			off_all: 'Yok',

			status: {
				AVAILABLE: 'Önerilen',
				DEPRECATED: 'Mevcut değil',
				COMING_SOON: 'Yakında',
			},
			is_activated: 'Seçildi',
			set_active: 'Seç',
			unset_active: 'Devre dışı bırak',
			preview: 'Önizle',
			is_free: 'Ücretsiz',
			buy: 'Satın al',
			bought: 'Satın alındı',
			purchased: 'Satın alındı',
		},
		empty: {
			all: 'Mevcut geliştirme yok',
			purchased: 'Satın alınmış geliştirme yok',
		},

		toast: {
			error: 'Bir hata oluştu',
			notEnoughMoney: 'Yetersiz bakiye',
			itemBought: 'Geliştirme satın alındı',
			itemActivated: 'Geliştirme etkinleştirildi',
			itemDeactivated: 'Geliştirme devre dışı bırakıldı',
		},
		confirmPurchase: {
			title: 'Satın Almayı Onayla',
			message: 'Bu ürünü satın almak istediğinizden emin misiniz?',
			confirm: 'Evet, satın al',
			cancel: 'İptal',
		},
	},

	demo: {
		title: 'Ücretsiz demo ders',
		tutorial: {
			title: 'Talimatlar',
			text:
				"Indigo Mental ile online demo mental aritmetik dersine hoş geldiniz.\nIndigo Mental, dünyadaki en iyi mental aritmetik okuludur. Şirketin yıllara dayanan deneyimi ve öğrencilerin dünya çapındaki olimpiyatlardaki başarıları, bu yöntemin etkili, benzersiz ve işleyen bir yöntem olduğunu kanıtlamaktadır. Birçok veli, çocuklarının sadece aritmetikte değil, diğer bilimlerde, müzikte ve sporda gösterdiği başarıları gördükçe yöntemin etkinliğine ikna olmuştur.\nMental aritmetik, hızlı zihinsel hesaplama için Japon bir yöntemdir ve çocuğun zihinsel yeteneklerini hızla geliştirir. Eğitim süreci, özel Japon abaküsleri (Soroban) üzerinde gerçekleştirilir. Mental aritmetik, beynin sol ve sağ yarım kürelerini eş zamanlı çalıştırarak görsel hafızayı, dikkat yoğunluğunu, yaratıcı düşünceyi ve çocuğun hayal gücünü geliştirir.\nŞimdi mental aritmetiği öğrenmeye başlayalım. Bunun için aşağıdaki videodaki 'PLAY' düğmesine basın, dinleyin ve tekrarlayın.",
		},
	},

	disableStudent: {
		btn: 'Öğrenciyi devre dışı bırak',
		list: 'Deaktivasyon tarihi olmayan öğrenciler',
		modal: {
			title: 'Öğrencinin programdan bağlantısının kesilmesi',
			description: 'Öğrenciyi programdan ayırmak üzeresiniz',
			fieldLabel: 'Ay seçin',
			btnSubmit: 'Devre dışı bırak',
			btnCancel: 'İptal',
		},
	},
}
